
import { useMemo } from 'react';
import { Client } from '@/models/Client';
import { fuzzyMatch } from '@/utils/fuzzySearch';

export const useFuzzyClientSearch = (clients: Client[], searchTerm: string) => {
  return useMemo(() => {
    if (!searchTerm.trim()) {
      return clients;
    }

    return clients.filter(client => {
      const fullName = `${client.firstName} ${client.lastName}`;
      
      // Search in name
      if (fuzzyMatch(searchTerm, fullName)) {
        return true;
      }
      
      // Search in first name only
      if (fuzzyMatch(searchTerm, client.firstName)) {
        return true;
      }
      
      // Search in last name only
      if (fuzzyMatch(searchTerm, client.lastName)) {
        return true;
      }
      
      // Search in phone (if exists)
      if (client.phone && fuzzyMatch(searchTerm, client.phone, 0.8)) {
        return true;
      }
      
      // Search in email (if exists)
      if (client.email && fuzzyMatch(searchTerm, client.email, 0.7)) {
        return true;
      }
      
      return false;
    });
  }, [clients, searchTerm]);
};
